import { usePostApiAdminInviteAdmin } from '@sit/client-shared';
import Button from 'carbon-react/lib/components/button';
import Card, { CardColumn, CardRow } from 'carbon-react/lib/components/card';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Heading from 'carbon-react/lib/components/heading';
import Loader from 'carbon-react/lib/components/loader';
import Message from 'carbon-react/lib/components/message';
import Textbox from 'carbon-react/lib/components/textbox';
import { useState } from 'react';
import GoBackButton from '../../components/GoBackButton';

const ResendInvite = () => {
  const {
    mutate: inviteAdmin,
    isPending,
    error,
    data,
    reset,
  } = usePostApiAdminInviteAdmin();
  const [formData, setFormData] = useState(() => ({
    intacctCompanyId: '',
    username: '',
    email: '',
  }));
  const [visited, setVisited] = useState(() => ({
    intacctCompanyId: false,
    username: false,
    email: false,
  }));

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setVisited((prevState) => ({
      ...prevState,
      [name]: true,
    }));
  };

  const errors = Object.keys(formData).filter(
    (key) =>
      formData[key as keyof typeof formData] === '' &&
      visited[key as keyof typeof visited] === true,
  ).length;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (errors > 0) return;
    if (!formData.intacctCompanyId || !formData.username || !formData.email) {
      setVisited({
        intacctCompanyId: true,
        username: true,
        email: true,
      });
      return;
    }
    inviteAdmin({
      body: {
        intacctCompanyId: formData.intacctCompanyId,
        username: formData.username,
        email: formData.email,
      },
    });
  };

  const closeModal = () => reset();

  return (
    <div className="intacct-admin-inner-container">
      <GoBackButton />
      <Card>
        <CardRow>
          <CardColumn align="left">
            <Heading title="Re-send SIT admin invitation" mt={2} />
          </CardColumn>
        </CardRow>
        <Form
          errorCount={errors}
          onSubmit={handleSubmit}
          saveButton={
            <CardRow>
              <CardColumn>
                <Button buttonType="primary" type="submit">
                  {isPending ? (
                    <Loader isActive isInsideButton />
                  ) : (
                    'Resend invitation'
                  )}
                </Button>
              </CardColumn>
            </CardRow>
          }
        >
          <Textbox
            error={
              formData.intacctCompanyId === '' && visited.intacctCompanyId
                ? 'This field is required'
                : ''
            }
            label="Intacct company ID"
            name="intacctCompanyId"
            onChange={handleInputChange}
            required
            value={formData.intacctCompanyId}
          />
          <Textbox
            error={
              formData.username === '' && visited.username
                ? 'This field is required'
                : ''
            }
            label={'Username'}
            name="username"
            onChange={handleInputChange}
            required
            value={formData.username}
          />
          <Textbox
            error={
              formData.email === '' && visited.email
                ? 'This field is required'
                : ''
            }
            label={'Email'}
            name="email"
            onChange={handleInputChange}
            required
            value={formData.email}
          />
          <Message variant="error" open={!!error}>
            {JSON.stringify(error?.message || '')}
          </Message>
        </Form>
      </Card>
      <Dialog onCancel={closeModal} title="Success" open={!!data}>
        <div>
          <span>
            Your invitation has been successfully sent. If the user still does
            not receive the invitation, please send them this link:
            {data?.inviteLink}
          </span>
        </div>
        <div className="intacct-admin-modal-footer">
          <Button buttonType="primary" onClick={closeModal}>
            OK
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default ResendInvite;
